import React, { Component } from 'react';
import Decorator from '../../functions/decorator';

const ThumbnailOnlyBanner = function(props) {
    let customImageMaxSize = {
        height: (props.children.imageMaxHeight ? props.children.imageMaxHeight : 125).toString() + 'px',
        width: (props.children.imageMaxWidth ? props.children.imageMaxWidth : 125).toString() + 'px'
    }
    return (
        <div className="container mt-3 mb-3">
            <div className="media mt-1 mb-2 p-2" style={{flexWrap: 'wrap'}}>
                <img style={customImageMaxSize} className="mr-3" src={props.children.imageSmall} alt="Generic placeholder image" />
                <div className="media-body">
                    <h2 className="mt-0">{props.children.headerText}</h2>
                    <div className="col-sm mt-2 mb-3">
                        <i>{props.children.description ? Decorator.multiLineParagraph(props.children.description, '') : ''}</i>
                    </div>
                </div>
            </div>
            {props.children.alternateSection ?
                <div className={"row"}>
                    <div className="col">
                        {props.children.alternateSection}
                    </div>
                </div>
                : ''}
        </div>
    )
};

export default ThumbnailOnlyBanner;